//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('fabricsGrp', {
//        templateUrl: 'views/components/views/fabricsGrp/fabricsGrp.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'fabricsGrpService', function ($stateParams, stateService, fabricsGrpService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let fabricsGrpId = $stateParams.fabricsgrp_id;
            
//            vm.model = {
//                fabricsGrpId: fabricsGrpId,
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await fabricsGrpService.getEdit({ fabricsgrp_id: fabricsGrpId }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                fabricsGrpService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
